The public web URL to submit an application for the posted job ad on SEEK.

This is null for job ads that use a link-out application method.
